<template src='./TarjetasFormulariosMomentos.html'></template>
<script>
import { consultarInformacionTarjetaEspecifica } from "../../apiService/request/CrudFormulario.js";
import { actualizarFormulario } from "../../apiService/request/CrudFormulario";
import { eliminarFormulariosExistentes } from "../../apiService/request/CrudFormulario";
import metodos_comunes from "../../js/metodos_comunes";
import { serverBus } from "../../main";
export default {
  data() {
    return {
      gridTemplate: "1fr 1fr 1fr",
      bandera_ver_mas: false,
      informacionTarjetaEspecifica: [],
      banderaMostrarTarjetaCompleta: false,
      banderaVolver: false,
      disabledDates: date => {
        const day = date.getDay();
        return (
          day === 0 ||
          day === 1 ||
          day === 2 ||
          day === 3 ||
          day === 4 ||
          day === 5 ||
          day === 6
        );
      },
      banderaHabilitarInputs: false,
      verCategoria: "",
      banderaFormularioExistenteAbierto: false
    };
  },
  created() {
    serverBus.$on(
      "abrirTarjetaFormulario",
      (id_formulario, nombreCategoria) => {
        this.informacionTarjetaEspecifica =[]
        this.abrirTarjetaFormularioMomento(id_formulario);
      }
    );
  },
  beforeDestroy() {
    serverBus.$off("abrirTarjetaFormulario");
  },
  computed: {
    getFormulariosMomentosllenos() {
      return this.$store.getters.getFormulariosMomentosllenos;
    },
    // getIdFormulario() {
    //   if(this.$store.getters.getIdFormulario!=null){
    //     console.log('formulario a consultar en componente:',this.$store.getters.getIdFormulario)
    //     this.abrirTarjetaFormularioMomento(this.$store.getters.getIdFormulario);
    //   }
    //   return this.$store.getters.getIdFormulario;
    // }
  },
  watch: {
    getFormulariosMomentosllenos() {},
    getIdFormulario() {}
  },
  methods: {
    habilitarInputs: function() {
      this.banderaHabilitarInputs = true;
      serverBus.$emit("banderaHabilitarInputs", this.banderaHabilitarInputs);
    },
    cambiarIconoModal(src) {
      this.$store.dispatch("cambiarIconoModal", src);
    },
    verMas: function() {
      this.bandera_ver_mas = !this.bandera_ver_mas;
    },
    verCategoriaFormulario: function(nombreCategoria) {
      if (this.verCategoria == nombreCategoria) {
        this.verCategoria = "";
      } else {
        this.verCategoria = nombreCategoria;
      }
    },
    abrirTarjetaFormularioMomento: function(idFormulario) {
      this.$store.dispatch("setIdFormulario", idFormulario);
      this.consultarInformacionTarjetaEspecificaMomento();
      this.banderaFormularioExistenteAbierto = true;
      this.$store.dispatch(
        "setBanderaFormularioExistenteAbierto",
        this.banderaFormularioExistenteAbierto
      );
    },
    async consultarInformacionTarjetaEspecificaMomento() {
      const respuesta = await consultarInformacionTarjetaEspecifica(
        this.$store.getters.getIdFormulario
      );
      this.banderaMostrarTarjetaCompleta = true;
      this.banderaHabilitarInputs = false;
      serverBus.$emit("banderaHabilitarInputs", this.banderaHabilitarInputs);
      this.informacionTarjetaEspecifica = respuesta.data.data;
      this.$store.dispatch(
        "setNombreFormulario",
        this.informacionTarjetaEspecifica.nombre
      );
    },
    construirVariablesActualizar: function() {
      const variablesFormulariosExistentes = this.informacionTarjetaEspecifica.variable;
      const self = this;
      let valorPorID;
      let variablesActualizar = [];
      Object.keys(variablesFormulariosExistentes).map(function(elemento) {
        valorPorID = "";
        switch (variablesFormulariosExistentes[elemento].tipo) {
          case "string":
            const nombreVariable =
              variablesFormulariosExistentes[elemento].nombre;
            valorPorID = self.$refs[nombreVariable][0].$el.value;
            break;
          case "fecha":
            valorPorID =
              Date.parse(self.$refs[variablesFormulariosExistentes[elemento].nombre][0]
              .$el.getElementsByTagName("input")[0].value) + 57600000;
            break;
          case "lista":
            valorPorID = self.$refs[variablesFormulariosExistentes[elemento].nombre][0]
            .$el.getElementsByTagName("input")[0].value;
            break;
          case "numero":
            valorPorID = parseInt(self.$refs[variablesFormulariosExistentes[elemento].nombre][0].$el.value);
            break;
        }
        if (
          variablesFormulariosExistentes[elemento].valor != valorPorID &&
          valorPorID != "" &&
          valorPorID != null
        ) {
          variablesActualizar.push({
            nombre: elemento,
            valor: valorPorID,
            nombre_campo: metodos_comunes.reemplazarCaracteresEspeciales(
              variablesFormulariosExistentes[elemento].nombre
            )
          });
        }
      });
      this.guardar(
        this.informacionTarjetaEspecifica.docId,
        variablesActualizar
      );
    },
    async guardar(id_formulario, variablesActualizar) {
      try {
        if (variablesActualizar.length > 0) {
          const respuesta = await actualizarFormulario(this.$store.getters.getIdFormulario,this.$store.getters.getNombreFormulario,variablesActualizar, 'formularios',this.$store.state.provider_email);
          // serverBus.$emit("formularioActualizadoExitosamenteMomento", respuesta);
          // this.banderaMostrarTarjetaCompleta=false
          this.$store.dispatch("cambiarEstadoModal", true);
          this.$store.dispatch("cambiarMensajeModal", respuesta);
          this.banderaHabilitarInputs = false;
          this.regresar();
          serverBus.$emit(
            "banderaHabilitarInputs",
            this.banderaHabilitarInputs
          );
        }
      } catch (err) {
        this.$store.dispatch("cambiarEstadoModal", true);
        this.$store.dispatch("cambiarMensajeModal", respuesta);
      }
    },
    async eliminarFormulario(id_formulario) {
      const respuesta = await eliminarFormulariosExistentes(id_formulario);
      serverBus.$emit("formularioActualizadoExitosamenteMomento", respuesta);
      this.banderaMostrarTarjetaCompleta = false;
      this.$store.dispatch("cambiarEstadoModal", true);
      this.$store.dispatch("cambiarMensajeModal", respuesta);
      this.regresar();
    },
    regresar: function() {
      // this.banderaHabilitarInputs=false,
      this.$store.dispatch("setVariablesFormularios", []);
      this.$store.dispatch("setBanderaFormularioExistenteAbierto", false);
      serverBus.$emit("banderaHabilitarInputs", this.banderaHabilitarInputs);
      serverBus.$emit("formularioActualizadoExitosamenteMomento");
      this.banderaMostrarTarjetaCompleta = false;
    }
  }
};
</script>
<style lang="scss" scoped src='./TarjetasFormulariosMomentos.scss'>
</style>



// WEBPACK FOOTER //
// src/components/TarjetasFormulariosMomentos/TarjetasFormulariosMomentos.vue